"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contratosListNormalizer = void 0;
const contratos_normalizer_1 = require("../contratos-normalizer");
const contratosListNormalizer = (data) => {
    const dataContratosNormalizado = [];
    const { contratosList } = data.fields;
    if (contratosList && Array.isArray(contratosList) && contratosList.length > 0) {
        contratosList.forEach((modulo) => {
            var _a;
            if ((_a = modulo === null || modulo === void 0 ? void 0 : modulo.data) === null || _a === void 0 ? void 0 : _a.fields) {
                const contratos = {};
                contratos.title = modulo.name;
                contratos.alias = modulo.alias;
                contratos.modules = (0, contratos_normalizer_1.contratosOrionNormalizer)(modulo.data.fields.MODULO_PRINCPAL_CONTRATOS);
                dataContratosNormalizado.push(contratos);
            }
        });
    }
    return dataContratosNormalizado;
};
exports.contratosListNormalizer = contratosListNormalizer;
exports.default = exports.contratosListNormalizer;
//# sourceMappingURL=index.js.map